/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getParamedics } from 'app/entities/paramedic/paramedic.reducer';
import { getEntities as getTenants } from 'app/entities/tenant/tenant.reducer';
import { LocationBehavior } from 'app/shared/model/enumerations/location-behavior.model';
import { UniquenessBehavior } from 'app/shared/model/enumerations/uniqueness-behavior.model';
import { createEntity, getEntity, reset, updateEntity } from './patient-identifier-type.reducer';

export const PatientIdentifierTypeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const paramedics = useAppSelector(state => state.paramedic.entities);
  const tenants = useAppSelector(state => state.tenant.entities);
  const patientIdentifierTypeEntity = useAppSelector(state => state.patientIdentifierType.entity);
  const loading = useAppSelector(state => state.patientIdentifierType.loading);
  const updating = useAppSelector(state => state.patientIdentifierType.updating);
  const updateSuccess = useAppSelector(state => state.patientIdentifierType.updateSuccess);
  const locationBehaviorValues = Object.keys(LocationBehavior);
  const uniquenessBehaviorValues = Object.keys(UniquenessBehavior);

  const handleClose = () => {
    navigate(`/patient-identifier-type${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getParamedics({}));
    dispatch(getTenants({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...patientIdentifierTypeEntity,
      ...values,
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      paramedic: paramedics.find(it => it.id.toString() === values.paramedic?.toString()),
      tenant: tenants.find(it => it.id.toString() === values.tenant?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          locationBehavior: 'REQUIRED',
          uniquenessBehavior: 'UNIQUE',
          ...patientIdentifierTypeEntity,
          doctor: patientIdentifierTypeEntity?.doctor?.id,
          paramedic: patientIdentifierTypeEntity?.paramedic?.id,
          tenant: patientIdentifierTypeEntity?.tenant?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientIdentifierType.home.createOrEditLabel" data-cy="PatientIdentifierTypeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientIdentifierType.home.createOrEditLabel">
              Create or edit a PatientIdentifierType
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-identifier-type-id"
                  label={translate('tinyMedicRestApp.patientIdentifierType.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.name')}
                id="patient-identifier-type-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.uuid')}
                id="patient-identifier-type-uuid"
                name="uuid"
                data-cy="uuid"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.description')}
                id="patient-identifier-type-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.format')}
                id="patient-identifier-type-format"
                name="format"
                data-cy="format"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.required')}
                id="patient-identifier-type-required"
                name="required"
                data-cy="required"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.formatDescription')}
                id="patient-identifier-type-formatDescription"
                name="formatDescription"
                data-cy="formatDescription"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.validator')}
                id="patient-identifier-type-validator"
                name="validator"
                data-cy="validator"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.locationBehavior')}
                id="patient-identifier-type-locationBehavior"
                name="locationBehavior"
                data-cy="locationBehavior"
                type="select"
              >
                {locationBehaviorValues.map(locationBehavior => (
                  <option value={locationBehavior} key={locationBehavior}>
                    {translate(`tinyMedicRestApp.LocationBehavior.${locationBehavior}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.uniquenessBehavior')}
                id="patient-identifier-type-uniquenessBehavior"
                name="uniquenessBehavior"
                data-cy="uniquenessBehavior"
                type="select"
              >
                {uniquenessBehaviorValues.map(uniquenessBehavior => (
                  <option value={uniquenessBehavior} key={uniquenessBehavior}>
                    {translate(`tinyMedicRestApp.UniquenessBehavior.${uniquenessBehavior}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.microSec')}
                id="patient-identifier-type-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.timestampentry')}
                id="patient-identifier-type-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.lastupdated')}
                id="patient-identifier-type-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.cursor')}
                id="patient-identifier-type-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.active')}
                id="patient-identifier-type-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.prefix')}
                id="patient-identifier-type-prefix"
                name="prefix"
                data-cy="prefix"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.postFix')}
                id="patient-identifier-type-postFix"
                name="postFix"
                data-cy="postFix"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifierType.prefixYearSno')}
                id="patient-identifier-type-prefixYearSno"
                name="prefixYearSno"
                data-cy="prefixYearSno"
                check
                type="checkbox"
              />
              <ValidatedField
                id="patient-identifier-type-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.patientIdentifierType.doctor')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-identifier-type-paramedic"
                name="paramedic"
                data-cy="paramedic"
                label={translate('tinyMedicRestApp.patientIdentifierType.paramedic')}
                type="select"
              >
                <option value="" key="0" />
                {paramedics
                  ? paramedics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-identifier-type-tenant"
                name="tenant"
                data-cy="tenant"
                label={translate('tinyMedicRestApp.patientIdentifierType.tenant')}
                type="select"
                required
              >
                <option value="" key="0" />
                {tenants
                  ? tenants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-identifier-type" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientIdentifierTypeUpdate;
